/**
 * loadScript
 *
 * Asynchronous loader for external scripts
 *
 * @param src - Source URL for the script
 * @returns
 */
export const loadScript = (src: string): Promise<Event> =>
    new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.async = true;
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
    });

/**
 *
 * @param src
 * @param check
 * @returns
 */
export const scriptLoaderFactory = <T>(
    src: string,
    check: () => T | undefined,
) => {
    let loadingPromise: Promise<T | undefined> | undefined;

    return () => {
        const hasLoaded = check();

        if (hasLoaded) {
            return Promise.resolve(hasLoaded);
        }

        if (loadingPromise) return loadingPromise;

        loadingPromise = loadScript(src).then(() => check());

        loadingPromise
            .catch((err) => console.log(err))
            .finally(() => {
                loadingPromise = undefined;
            });

        return loadingPromise;
    };
};
